// extracted by mini-css-extract-plugin
export default {"prizeManagement":"prize_prizeManagement__1h3Ak","header":"prize_header__SVP1b","sortableRow":"prize_sortableRow__28EXQ","dragging":"prize_dragging__pGIIp"};